/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VisitApi } from '../api/visit.api';
import { switchMap, map } from 'rxjs/operators';
import { VisitData, Visit } from '../../../interfaces/ehr/visit';
import { PatientVital } from '../../../../_models/patient-vital';

@Injectable()
export class VisitService extends VisitData {

  constructor(private api: VisitApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<Visit[]> {
    return this.api.list(url);
  }

  getById(url:string, data:Visit): Observable<Visit>{
      return this.api.getById(url,data);
  }

  create(url: string, data:Visit): Observable<Visit> {
    return this.api.add(url,data);
  }

  update(url: string, data:Visit): Observable<Visit> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  // adviceList(url: string): Observable<any> {
  //   return this.api.adviceList(url);
  // }
  // vitalTrends(url: string): Observable<any> {
  //   return this.api.vitalTrendList(url);
  // }
  getDashboardData(url: string): Observable<any> {
    return this.api.getDashboardData(url);
  }
  getDashboardList(url: string): Observable<any[]> {
    return this.api.getDashboardList(url);
  }
  getLastVisit(url: string): Observable<any[]> {
    return this.api.getLastVisit(url);
  }
}
